/**
 * Shared base configuration inherited by every environment.
 * Add any key here that has the same value across all environments,
 * or that is always overridden at runtime via window['env'].
 */

/** Shape of the runtime config injected by `public/env.js` (see Dockerfile entrypoint). */
interface RuntimeEnv {
  support?: { url?: string };
  eserviceApiBase?: string;
  baseAccessGroup?: string;
  auth0?: { domain?: string; clientId?: string };
}

const runtimeEnv: RuntimeEnv = (window as unknown as { env?: RuntimeEnv }).env ?? {};

export const baseEnvironment = {
  production: false,
  support: {
    url: runtimeEnv.support?.url,
  },
  eserviceApiBase: runtimeEnv.eserviceApiBase,
  baseAccessGroup: runtimeEnv.baseAccessGroup,
  auth0: {
    domain: runtimeEnv.auth0?.domain ?? '',
    clientId: runtimeEnv.auth0?.clientId ?? '',
  },
  markantGroupsClaim: 'markant_groups',
  /** URLs to which the Auth0 HTTP interceptor attaches the Bearer token. */
  allowedApiUrls: [] as string[],
};
